import {post} from '@/config/config.js'
import {urlpostfix,jsonpostfix} from '@/config/global.js'

/*查询数据接口*/
export function getmaptiondata(data){
  return post(`${urlpostfix}api/activity/twenty/list`,data);
}



// WEBPACK FOOTER //
// ./src/api/maprotation.js